import Vue from 'vue'
import Vuex from 'vuex'
import api from "../api/index";
Vue.use(Vuex);
// 检查 sessionStorage 中是否存在标记
const isNewSession = sessionStorage.getItem('isNewSession') === null;
if (isNewSession) {
  // 标记会话已开始
  sessionStorage.setItem('isNewSession', 'false');
}
export default new Vuex.Store({
    state: {
        curtAct: null, //中文电脑端选中的底部导航index
        curtAct2: null, //中文手机端选中的底部导航index
        headAct: 0, //中文电脑端选中的头部导航index
        enAct1: 0,//英文电脑端选中的头部导航index
        useAge: 1,//1不知道多大，2已满18多，3小于18岁
        loadPage: true,
        headList: [],
    },
    mutations: {
        // 中文头部分类导航
        GETHEADLIST(state, dataList) {
            state.headList = dataList;
        },
        GETLAN(state, data) {
            if(state.language==''){
                state.language = data;
            }
        },
        SET_CURRENT_TAB(state, index) {
            state.curtAct = index;
        },
        HEAD_NAV(state, index){
            state.headAct = index;
        },
    },
    actions: {
        // 中文头部分类导航
        async getHeadList({commit}) {
            const res = await api.cate();
            const data1=res.data;
            if(res.code == 1){
                commit('GETHEADLIST',data1);
            }
        },
        // 中文电脑端头部导航
        changeNav({commit}, index) {
            commit('HEAD_NAV', index);
        },
        // 中文手机端底部导航
        changeTab2({ commit }, index) {
            commit('SET_CURRENT_TAB', index);
        },
    },
})